export const trackExternalLinkClick = (url: string): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'click', {
      event_category: 'External Link',
      event_label: url,
      transport_type: 'beacon',
      value: 1,
    });
  }
};
